var _paymentMethodPrice, ref;
const getCartPrices = (prices, shippingMethod)=>{
    var ref2, ref1;
    return {
        discountPrice: prices.discount.amount,
        paymentMethodPrice: (_paymentMethodPrice = prices.paymentMethodPrice) !== null && _paymentMethodPrice !== void 0 ? _paymentMethodPrice : undefined,
        subTotalPrice: prices.subtotal,
        shippingPrice: prices.shippingPrice,
        totalPrice: prices.gross,
        taxPrice: prices.tax.amount,
        taxRate: (ref = (ref2 = prices.tax.portions[0]) === null || ref2 === void 0 ? void 0 : ref2.rate) !== null && ref !== void 0 ? ref : 0,
        shippingTaxRate: (shippingMethod === null || shippingMethod === void 0 ? void 0 : (ref1 = shippingMethod.pricing) === null || ref1 === void 0 ? void 0 : ref1.taxRate) || 0,
        shippingDiscount: prices.shippingPrice ? (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.pricing.priceWithoutDiscounts) - prices.shippingPrice : 0
    };
};

export { getCartPrices };
//# sourceMappingURL=get-cart-prices.js.map
